module.exports = __webpack_public_path__ + "media/images/emblems/Himmelried-blason-b001f9bea24c4170255939790df287c6.png";